import React, {useEffect, useState, useRef} from 'react';
import CardHeader from '../../components/common/card-header/CardHeader';
import {Card, FlexItem, FlexLayout, Link, Spinner, StackLayout, Text} from '@salt-ds/core';
import StepTracker from '../../components/common/StepTracker';
import ForgotPasswordAuthenticateForm from './ForgotPasswordAuthenticateForm';
import Constants from '../../components/common/Constants';
import '../CommonCard.css';
import {useIntl} from 'react-intl';
import CardAlert from "../../components/common/card-alert/CardAlert";
import {customerServiceLink} from '../../common/ApiUtils';
import {useLocation, useNavigate} from "react-router";


function ForgotPasswordAuthenticate() {
  const navigate = useNavigate();
  const location = useLocation();
  const mainRef = useRef(null);
  const [orgIdVisible, setOrgIdVisible] = useState(false);
  const forgotOrgIdUserIdLink =<Link color="info" tabIndex={0} onClick={() => handleNavigateToCard()} onKeyPress={(e) => {
                                       if (e.key === "Enter" || e.key === " ") {
                                         handleNavigateToCard();
                                       }
                                     }} className="links">{Constants.forgotUserIdOrgIdLabel}</Link>;
  const intl = useIntl();

  useEffect(() => {
    document.title = intl.formatMessage({id: 'logon.ui.forgotpassword.step1.page.title'});
    // Set focus to main element for screen reader announcement
    if (mainRef.current) {
      mainRef.current.focus();
    }

    if (location.state?.from !== Constants.login && sessionStorage.getItem("previousPage") !== Constants.login && location.state?.from !== Constants.profileRegistrationCompleted && location.state?.from !== Constants.forgotUserOrOrgIdComplete && location.state?.from !== Constants.forgotPasswordProvideAccessCode) {
      navigate('/');
    }
    }, [intl,navigate,location]);

  const [hasError, setHasError] = useState(false);
  const [errorMessage, setErrorMessage] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const showErrorOnPage = (error) => {
    setErrorMessage(error);
    setHasError(true);
  }

  function handleNavigateToCard() {
    navigate('/forgotUserOrOrgIdEmail', { state: { from: '/forgotPassword' } });
  }


  return (
    <main ref={mainRef} role="main" aria-label="Forgot Password Authenticate" tabIndex="-1">
      <FlexLayout className={"page-content"}>
        {isLoading ? (
            <FlexItem className="spinner-wrapper">
              <Spinner data-testid="spinner-loading" aria-label="loading" role="status" size="medium" style={{marginLeft: "50%"}} />
            </FlexItem>
        ) : (
            <FlexItem className={`error-wrapper ${hasError ? 'visible' : ''}`}>
              <div>
                <CardAlert status={"error"} setHasError={setHasError}>{errorMessage}</CardAlert>
              </div>
            </FlexItem>
        )}
        <FlexItem>
          <Card className="card-wrapper">
            <FlexItem className="card-content">
              <StackLayout gap={2}>
                <CardHeader heading={Constants.forgotPasswordTitle} subheading={Constants.forgotPasswordStep1Title}
                            style={{maxWidth: "15.5rem"}} />

                <StepTracker label1={intl.formatMessage({id: 'logon.ui.forgotpassword.flow.step1'})} step1="active"
                             label2={intl.formatMessage({id: 'logon.ui.forgotpassword.flow.step2'})} step2="pending"
                             label3={intl.formatMessage({id: 'logon.ui.forgotpassword.flow.step3'})} step3="pending" />
                <FlexItem>
                  <Text>
                    {orgIdVisible ? Constants.forgotPasswordStep1OrgIdInstructionHeader(forgotOrgIdUserIdLink, customerServiceLink) : Constants.forgotPasswordStep1InstructionHeader(forgotOrgIdUserIdLink, customerServiceLink)}
                  </Text>
                </FlexItem>
                <ForgotPasswordAuthenticateForm orgIdVisible={orgIdVisible} setOrgIdVisible={setOrgIdVisible} showErrorOnPage={showErrorOnPage}
                                                isLoading={isLoading} setIsLoading={setIsLoading}/>
              </StackLayout>
            </FlexItem>
          </Card>
        </FlexItem>
      </FlexLayout>
    </main>
  );
}

export default ForgotPasswordAuthenticate;